module.exports = __webpack_public_path__ + "error-404.svg?96758d270fab76cb64df2fcb460f48a5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error-404.svg
// module id = 121
// module chunks = 0